import { connect } from 'react-redux';

import ExternalScriptView from "./ExternalScriptView.jsx";
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'external_script');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.externalScript.deactivation.deactivating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
  }
}

const ExternalScriptPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(ExternalScriptView);

export default withUseHooks(ExternalScriptPage);
